import React, {useState, useEffect, useContext, useRef} from "react";
import {useParams} from "react-router-dom";
import ListPanel from '../administration/components/ListPanel';
import EditPanel from '../administration/components/EditPanel';
import {useHistory} from 'react-router-dom';
import {store} from '../../context/store';
import {INPUT_TYPE_TEXT} from "../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDBCONCATENATION} from "../../constants/input-types";
import {functions} from "../../constants/common-functions";
import {TRUE} from "../../constants/general-constants";
import {STRINGIFY} from "../../constants/general-constants";
import {NO_STRINGIFY} from "../../constants/general-constants";
import AdminListPanelGeographies from '../administration/components/AdminListPanelGeographies';
import {YES_NO_OPTIONS} from "../../constants/general-constants";
import EditButtonPanel from '../administration/components/EditButtonPanel';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";

export default function AdministrationHomeResourcesEdit(){
	
	const globalState = useContext(store);
	const history = useHistory(); 
	const [entityIcon, setEntityIcon] = useState("");
	const [entityName, setEntityName] = useState("New Home Resource");
	const [existingFilename, setExistingFilename] = useState("");
	
	const refIcon = useRef(null);
	const refName = useRef(null);
	const refFile = useRef(null);
	const refColor = useRef(null);
	const refDescription = useRef(null);
	
	const id = useParams()["id"];
	
	useEffect(() => {
		loadData();
	}, [id]);
	
	const loadData = () => {
		const timer = setTimeout(() => {
			functions.getObjectFromAjax("/resolution/homeresource?id=" + id, null, initialiseFields);
		}, 100);
	};
	
	const getEntityIcon = () => {
		return refIcon.current.value;
	};
	
	const getEntityName = () => {
		return refName.current.value;
	};
	
	const initialiseFields = (entity) => {
		const timer = setTimeout(() => {
			try{
				setEntityIcon(entity.icon);
				setEntityName(entity.name);
				setExistingFilename(entity.filename);
				refIcon.current.value = entity.icon;
				refName.current.value = entity.name;
				refColor.current.value = entity.color;
				refDescription.current.value = entity.description;
				
			}
			catch(e){}
		}, 100);
	
		
	};
	
	const mainComponentRows = [
		{ref:refIcon, id:"2", title:"Icon", inputType:INPUT_TYPE_TEXT},
		{ref:refName, id:"3", title:"Name", inputType:INPUT_TYPE_TEXT},
		{ref:refColor, id:"4", title:"Color", inputType:INPUT_TYPE_TEXT},
		{ref:refDescription, id:"5", title:"Description", inputType:INPUT_TYPE_TEXT}
	];
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	const administrationHeader = {
		display:"flex",
		height:"60px",
		paddingLeft:"20px",
		alignItems:"center",
		color:"black"
	};
	
	const contentPanel = {
		display:"flex",
		width:"100%"
	};
	
	const getSubmitObject = () => {
		
		let submitObject = {
			id:id,
			filename:existingFilename,
			icon:refIcon.current.value,
			name:refName.current.value,
			color:refColor.current.value,
			description:refDescription.current.value
		};
		
		return submitObject
	}

	const goSubmit = () => {
		if(refFile.current.files.length === 0){
			functions.submitAjax("/resolution/homeresourcesave", 
			getSubmitObject(), saveEnd, STRINGIFY, handleSubmitError);
		}
		else{
			let formData = new FormData();
			formData.append("file", refFile.current.files[0]);
			formData.append("id", id);
			formData.append("name", refName.current.value);
			formData.append("icon", refIcon.current.value);	
			formData.append("color", refColor.current.value);	
			formData.append("description", refDescription.current.value);	
			functions.submitAjax("/resolution/homeresourcesavewithfile", 
			formData, saveEnd, NO_STRINGIFY, handleSubmitError);
		}
		
		
		
		
		
		
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		goCancel();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolution/homeresourcedelete", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	const goCancel = () => {
		history.goBack();
	};
	
	const filePanel = {
		display:"flex",
		width:"calc(50% - 50px)",
		backgroundColor:"#eee",
		borderRadius:"4px",
		flexDirection:"column",
		minHeight:"100px",
		marginLeft:"30px",
		paddingTop:"40px"
	};
	
	const editRow = {
		display:"flex",
		minHeight:"40px",
		alignItems:"center"
	};
	
	const editTitle = {
		display:"flex",
		width:"150px",
		fontSize:"12px",
		paddingLeft:"20px"
	};
	
	const fileInput = {
		display:"flex",
		width:"200px",
		height:"30px"
	};

	return (
		
			<div style={thisContainer}>
			<Header/>
				<LeftMenu/>
				<div style={administrationHeader}>
					Geography Edit: {entityName}
				</div>
				<div style={contentPanel}>
					<EditPanel
					title="Main Details"
						componentRows = {mainComponentRows}
					/>
					<div style={filePanel}>
						<div style={editRow}>
							<div style={editTitle}>
								Resource File
							</div>
							<input type="file" ref={refFile} style={fileInput}/>
						</div>
					</div>
				</div>
					<EditButtonPanel
					id={id}
					goSubmit={goSubmit}
					goDelete={goDelete}
					goCancel={goCancel}
					checkCodeUrl="homeresources"
					getCodeFunction={getEntityIcon}
					getNameFunction={getEntityName}
				/>
			</div>
		
	
	);
}